/* import __COLOCATED_TEMPLATE__ from './square-one-pricing-modal.hbs.js'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import styles from './square-one-pricing-modal.module.css';
let SquareOnePricingModal = (_dec = computed('args.modalOptions.{currentCost.amount,newCost.amount}'), _dec2 = computed('isRemoving'), _dec3 = computed('isRemoving', 'args.modalOptions.unitPrice'), _class = class SquareOnePricingModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "styles", _descriptor, this);
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
  }
  get isRemoving() {
    // see if we are adding or subtracting
    return this.args.modalOptions.currentCost.amount > this.args.modalOptions.newCost.amount;
  }
  get translationKeys() {
    return {
      perMonth: 'locations.edit.locationSettings.squareOne.modal.perMonth',
      current: 'locations.edit.locationSettings.squareOne.modal.current',
      total: 'locations.edit.locationSettings.squareOne.modal.total',
      preTax: 'locations.edit.locationSettings.squareOne.modal.preTax',
      button: 'locations.edit.locationSettings.squareOne.modal.button',
      ...(this.isRemoving ? {
        header: 'locations.edit.locationSettings.squareOne.modal.remove.header',
        description: 'locations.edit.locationSettings.squareOne.modal.remove.description',
        unit: 'locations.edit.locationSettings.squareOne.modal.remove.unit',
        billing: 'locations.edit.locationSettings.squareOne.modal.remove.billing'
      } : {
        header: 'locations.edit.locationSettings.squareOne.modal.add.header',
        description: 'locations.edit.locationSettings.squareOne.modal.add.description',
        unit: 'locations.edit.locationSettings.squareOne.modal.add.unit',
        billing: 'locations.edit.locationSettings.squareOne.modal.add.billing'
      })
    };
  }
  get modifiedUnitPrice() {
    const formatted = this.formatter.formatMoney(this.args.modalOptions.unitPrice);
    return this.isRemoving ? `-${formatted}` : formatted;
  }
  closeModal(value) {
    this.args.close(value);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "styles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return styles;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isRemoving", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "isRemoving"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translationKeys", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "translationKeys"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "modifiedUnitPrice", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "modifiedUnitPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _class);
export { SquareOnePricingModal as default };